<!-- @if (showToolbar) { -->
<!-- <app-toolbar></app-toolbar> -->
<!-- } -->

<div class="card">
  <p-table
    #dt
    [columns]="tableHeader"
    [value]="tableBody"
    selectionMode="single"
    [(selection)]="selectedProducts"
    [exportHeader]="'customExportHeader'"
    [metaKeySelection]="metaKey"
    [scrollable]="true"
    scrollHeight="400px"
    [virtualScroll]="true"
    [virtualScrollItemSize]="46"
    dataKey="id"
    editMode="row"
    [tableStyle]="{ 'min-width': '50rem' }"
  >
    <ng-template pTemplate="header" let-columns>
      <!-- Header Names -->
      <tr>
        <th></th>
        @for (col of columns; track col) {
          @if (col !== 'id') {
            <th id="table-header" (click)="selectColumn(col)">
              {{ col }}
            </th>
          }
        }
      </tr>

      <!-- Filter Inputs -->
      <tr>
        <td></td>
        @for (col of columns; track $index) {
          @if (col !== 'id') {
            <th id="table-filter-input">
              <p-columnFilter type="text" field="{{ col }}" placeholder="Filter {{ col }}" ariaLabel="Filter {{ col }}" />
            </th>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-editing="editing" let-ri="rowIndex" let-rowData let-columns="columns">
      <!-- Body Rows -->
      <tr [pSelectableRow]="rowData" pSelectableRowDblClick [pEditableRow]="rowData" (dblclick)="onRowEditInit(rowData)" (click)="selectData(rowData)">
        <td>
          <div class="flex align-items-center justify-content-center gap-2">
            <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(rowData)" class="p-button-sm"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(rowData)" class="p-button-sm p-button-success"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(rowData, ri)" class="p-button-sm p-button-danger"></button>
          </div>
        </td>
        @for (col of columns; track $index) {
          @if (col !== 'id') {
            <td [pEditableColumn]="rowData[col]" pEditableColumnField="{{ rowData[col] }}">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <div class="card flex flex-column md:flex-row gap-3">
                    @switch (col.type) {
                      @case ('button') {
                        <p-button label="{{ rowData[col] }}" name="button" [disabled]="col.isDisabled" />
                        <p-inputGroup> </p-inputGroup>
                      }
                      @case ('checkbox') {
                        <p-inputGroup>
                          <p-checkbox [(ngModel)]="checked" [binary]="true" inputId="binary" name="radioButton" [disabled]="col.isDisabled" label="{{ [rowData[col]] }}" />
                        </p-inputGroup>
                      }
                      @case ('date') {
                        <div class="card flex justify-content-center">
                          <p>{{ date }}</p>
                          <p-calendar [(ngModel)]="date" [showIcon]="true" inputId="buttondisplay" [showOnFocus]="false" dateFormat="dd.mm.yy" [disabled]="col.isDisabled" />
                        </div>
                      }
                      @case ('text') {
                        <p-inputGroup>
                          <p-inputGroupAddon>
                            <i class="pi pi-user"></i>
                          </p-inputGroupAddon>
                          <input pInputText type="text" [(ngModel)]="rowData[col]" [disabled]="col.isDisabled" />
                        </p-inputGroup>
                      }
                      @default {
                        <p>{{ rowData[col.field] }}</p>
                        <div class="card flex justify-content-center">
                          <input pInputText type="text" [(ngModel)]="rowData[col]" [disabled]="col.isDisabled" />
                        </div>
                      }
                    }
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  @if (rowData[col] === '[object Object]') {
                    @for (item of col; track $index) {
                      {{ rowData[col] }}
                    }
                  } @else if (rowData[col] === true || rowData[col] === false) {
                    <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': rowData[col] === true, 'text-red-500 pi-times-circle': rowData[col] === false }"></i>
                  } @else {
                    {{ rowData[col] }}
                  }
                </ng-template>
              </p-cellEditor>
            </td>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between">Nombre de résultat : {{ tableBody ? tableBody.length : 0 }}</div>
    </ng-template>
  </p-table>
</div>
